import { icsApi } from './api';

interface Params {
  apiVersion?: 'si-backend' | 'ics-api';
  signal?: AbortSignal;
  timeout?: number;
  url: string;
}

export async function getFileUrl({ signal, timeout, url }: Params): Promise<string> {
  const axiosResponse = await icsApi.get(url, {
    responseType: 'blob',
    signal,
    timeout,
  });

  // TODO: consider zod for validation
  const contentType = String(axiosResponse.headers['content-type'] ?? '');
  if (axiosResponse.status !== 200 || !contentType) {
    throw new Error(axiosResponse.data.error.message);
  }

  const blob = axiosResponse.data;
  const fileUrl = URL.createObjectURL(blob);

  return fileUrl;
}
